import { getCookieClient, setCookieClient } from '../utils/storage/utils'
import { getHostApis } from '../utils/host-browser-apis/getHost'
import { PARTNER_IDS, isPartnerId, type PartnerId } from './registry'

// qz.com articles read the same cookie: the Discover NTP and they share the host.
export const PARTNER_COOKIE = '_partner'
const PARTNER_COOKIE_MAX_AGE = 400 * 24 * 60 * 60

function fromHostOrUrl(): PartnerId | undefined {
  // A partner whose browser injects no API simply has no entry.
  const host: Partial<Record<PartnerId, unknown>> = getHostApis()
  const byHostApi = PARTNER_IDS.find(
    (id) => typeof host[id] === 'object' && host[id] !== null
  )
  if (byHostApi) {
    return byHostApi
  }
  const utmSource = new URLSearchParams(window.location.search).get(
    'utm_source'
  )
  return isPartnerId(utmSource) ? utmSource : undefined
}

/**
 * The traffic partner this visit comes from: the API its browser injects, else
 * the utm_source it opened the page with, else the cookie an earlier page in
 * this browser kept. Browser only; a server render never writes the cookie.
 */
export function resolvePartner(): PartnerId | undefined {
  if (import.meta.server) {
    return undefined
  }
  const partner = fromHostOrUrl()
  if (partner) {
    setCookieClient(PARTNER_COOKIE, partner, PARTNER_COOKIE_MAX_AGE)
    return partner
  }
  const stored = getCookieClient(PARTNER_COOKIE)
  return isPartnerId(stored) ? stored : undefined
}
